import React from 'react';
import codesysLogo from './CODESYS_logo.png';

export const CODESYSIcon = ({ className }) => (
  <img 
    src={codesysLogo} 
    alt="CODESYS" 
    className={className}
    style={{ objectFit: 'contain' }}
  />
); 